import { memo } from "react"
import { useSelector } from "react-redux"
import { LoadPanel } from "devextreme-react"
import { expenditureProfileSelector } from "redux/expenditure-profile/expenditureProfileSlice"
import { LoadingState } from "types/AppNav"

const ExpenditureProfileLoader = () => {
  const { loading } = useSelector(expenditureProfileSelector)
  return (
    <LoadPanel
      shadingColor="rgba(0,0,0,0.4)"
      position="center"
      visible={loading === LoadingState.LOADING}
      showIndicator
      shading
      showPane
    />
  )
}

export default memo(ExpenditureProfileLoader)
